// @flow
import React, { Children, useEffect, useRef, type Node } from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import {
  LayerHeaderButton,
  type LayerHeaderButtonProps,
} from './layer-header-button/LayerHeaderButton.jsx';

import { themes } from './LayerHeader.themes';

type LayerHeaderProps = {
  buttonLeft?: ?LayerHeaderButtonProps,
  buttonRight?: ?LayerHeaderButtonProps,
  children?: Node,
  className?: string,
  closeLabel?: string,
  hasContainer?: boolean,
  height: number,
  onClose?: (e?: SyntheticEvent<>) => void,
  theme?: string,
};

export function LayerHeader(props: LayerHeaderProps) {
  const {
    buttonLeft,
    buttonRight,
    children,
    className,
    closeLabel,
    hasContainer,
    height,
    onClose,
    theme = 'default',
  } = props;

  const layerButtonRef: { current: ?HTMLElement } = useRef();

  useEffect(() => {
    layerButtonRef.current && layerButtonRef.current.focus();
  }, []);

  const {
    thButtonLeft,
    thButtonRight,
    thChild,
    thClose,
    thCloseIconWidth,
    thCloseLabel,
    thInner,
    thRoot,
  } = themes[theme];

  return (
    <header className={classnames(className, thRoot)} style={{ height, maxHeight: height }}>
      <div
        className={classnames(thInner, { 'm-auto max-w-site w-full': hasContainer })}
        data-testid="LayerHeader-body"
      >
        <button
          className={thClose}
          data-testid="Layer-close"
          onClick={onClose}
          ref={layerButtonRef}
          type="button"
        >
          {!!closeLabel && <span className={thCloseLabel}>{closeLabel}</span>}
          <Icon name={ICONS.CROSS} width={thCloseIconWidth} />
        </button>
        {/* $FlowFixMe */}
        <LayerHeaderButton
          className={thButtonLeft}
          dataTestId="layer-header-button-left"
          {...buttonLeft}
          theme={theme}
        />
        {!!Children.count(children) && <div className={thChild}>{children}</div>}
        {/* $FlowFixMe */}
        <LayerHeaderButton
          className={thButtonRight}
          dataTestId="layer-header-button-right"
          {...buttonRight}
          theme={theme}
        />
      </div>
    </header>
  );
}
